import EtablissementT3252 from '@/generated/controls/etablissement/EtablissementT3252.vue';
import { defineComponent } from "vue";

export default defineComponent({ components: {},
    extends: EtablissementT3252
})

